import { compact } from "lodash-es"
import { useTranslation } from "react-i18next"
import { config } from "@oysterhr/core"

export enum Column {
  "name" = "name",
  "company" = "company",
  "startDate" = "startDate",
  "pricePaid" = "pricePaid",
  "priceInvoiced" = "priceInvoiced",
  "price" = "price",
  "provider" = "provider",
  "plan" = "plan",
  "dependents" = "dependents",
  "status" = "status",
}

const PRODUCTION_ENV_COLUMNS = [Column.price]
const TESTING_ENV_COLUMNS = [Column.pricePaid, Column.priceInvoiced]

type ColumnType = keyof typeof Column

interface UseColumnProps {
  hiddenColumns?: ColumnType[]
}

const TITLELESS_COLUMNS: Column[] = []
const TOOLTIPED_COLUMNS: Column[] = []

const ALL_COLUMNS = compact([
  Column.name,
  Column.company,
  Column.startDate,
  ...(config.isProductionEnvironment ? PRODUCTION_ENV_COLUMNS : TESTING_ENV_COLUMNS),
  Column.provider,
  Column.plan,
  Column.dependents,
  Column.status,
])

export const useColumns = ({ hiddenColumns }: UseColumnProps = { hiddenColumns: [] }) => {
  const { t } = useTranslation("benefits/BenefitsPage")

  const columns = ALL_COLUMNS.filter(column => !hiddenColumns?.includes(column))

  return columns.map(column => {
    const title = t(`table.columns.${column ?? "placeholder"}`)
    const tooltipText = t(`table.tooltips.${column ?? "placeholder"}`)

    return {
      key: column,
      title: TITLELESS_COLUMNS.includes(column) ? undefined : title,
      tooltipText: TOOLTIPED_COLUMNS.includes(column) ? tooltipText : undefined,
    }
  })
}
